import moment from 'moment-timezone';
import React, { useContext } from 'react';
import { MetaFormContext } from '../Components/AutosaveForm/MetaForm';
import { AutosaveIndicator, AutosaveStates } from '../Components/AutosaveIndicator';
import { ValidDateFormats } from '../Shared/DateUtilities';
import styles from './MedicationInfoHeader.module.css';
export function MedicationInfoHeader(props) {
    var formContext = useContext(MetaFormContext);
    var retryFunction = formContext.submitAllForms;
    var status = formContext.formSubmitting
        ? AutosaveStates.saving
        : formContext.formInvalid || formContext.formFailedToSave
            ? AutosaveStates.failed
            : AutosaveStates.saved;
    var updatedOnMoment = moment.utc(props.updatedOn).local();
    var updatedOn = updatedOnMoment.format(ValidDateFormats.PrettyPrintFullDateTimeWithBullet) + " by " + props.updatedBy;
    return (React.createElement("div", { className: styles.toolbar },
        React.createElement("div", { className: styles.datestamp, title: updatedOn, onClick: props.onClick },
            React.createElement("strong", null, "Last updated: "),
            React.createElement("span", { className: styles.updatedText, "data-test-id": 'last-updated' }, updatedOn)),
        React.createElement("div", { className: styles.controls },
            React.createElement(AutosaveIndicator, { retryFunction: retryFunction, saveState: status }))));
}
